import { Box, Button, CircularProgress, Pagination } from '@mui/material';
import { btnStatusPayment, customStyles, customStylesWhiteBg, pagination } from './LastOperations.sx';
import { grayFilter } from 'app/components/ThemeProvider/colors';
import Select from 'react-select';
import { PaymentStatusOption } from 'app/components/SelectOption';
import SelectValueContainer from 'app/components/SelectValueContainer';
import Filter from 'app/components/Filter';
import LastOperationsTable from './LastOperationsTable';
import React from 'react';
import useLastOperations from './useLastOperations';
import { AccountValue, LastOperationsType } from 'app/constants/types';

interface Props {
  bg?: boolean;
  tableData?: LastOperationsType[];
  menuHomeButtons?: any[];
  selectedAccount?: AccountValue;
  homePage?: boolean;
}

const LastOperations = (props: Props) => {
  const { bg, tableData, selectedAccount, homePage, menuHomeButtons } = props;
  const {
    t,
    filterBtns,
    getOptions,
    wrapperRef,
    searchRef,
    setSearchInput,
    btnId,
    handleSearch,
    handleDeleteSearch,
    // filterTransactionMutation,
    // setBtnId,
    searchInputValue,
    // setSearchInputValue,
    handleSearchInputValue,
    getValue,
    searchInput,
    onChange,
    isOptionSelected,
    handleChangeTransactionType,
    dataFilterTransactions,
    paymentType,
    setPaymentType,
    voen,
    setVoen,
    client,
    setClient,
    selectedPeriod,
    setSelectedPeriod,
    resNextDate,
    setNextResDate,
    resEndDate,
    setEndResDate,
    fromAmount,
    setFromAmount,
    toAmount,
    setToAmount,
    filterCounter,
    setFilterCounter,
    showCount,
    setShowCount,
    mainCount,
    setMainCount,
    showFilter,
    setShowFilter,
    handleSubmitFilter,
    isClean,
    setIsClean,
    resDate,
    setResDate,
    endDate,
    setEndDate,
    resetAllInput,
    isSuccessFilterTransactions,
    tableRow,
    loader,
    largeScreens,
    mediumScreens,
    handleMoveToTransfer,
    paymentStatus,
    isLoadingFilterTransactions,
    page,
    handleChangePage,
    setPage,
    handleCheckData,
    filterTransactionMutation,
    accNo,
    setAccNo,
  } = useLastOperations({ selectedAccount, homePage, tableData });

  if (loader) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          height: '543px',
        }}
      >
        <CircularProgress />
      </Box>
    );
  } else {
    return (
      <>
        {(dataFilterTransactions !== undefined || tableData?.length !== 0) && (
          <Box
            sx={{
              display: 'flex',
              p: !bg && '0 28px',
              mb: bg && '20px',
              justifyContent: 'space-between',
              // flexDirection: mediumScreens ? 'column' : 'row',
              flexWrap: 'wrap',
              gap: mediumScreens ? '16px' : null,
            }}
          >
            <Box sx={{ display: 'flex', gap: '8px' }}>
              {filterBtns.map((item, index) => (
                <Button
                  key={item.id}
                  color={'tertiary'}
                  sx={
                    btnId === item.id
                      ? { ...btnStatusPayment, background: grayFilter, boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)' }
                      : btnStatusPayment
                  }
                  onClick={() => handleChangeTransactionType(item.id)}
                >
                  {item?.icon}
                  {item.title}
                </Button>
              ))}
            </Box>
            <Box sx={{ display: 'flex', gap: '12px' }}>
              {/*{!largeScreens && (*/}
              <Select
                options={paymentStatus}
                styles={bg ? customStylesWhiteBg : customStyles}
                components={{
                  IndicatorSeparator: () => null,
                  MultiValueRemove: () => null,
                  Option: PaymentStatusOption,
                  ValueContainer: SelectValueContainer,
                }}
                placeholder={t('homePage.paymentStatus')}
                isSearchable={false}
                isMulti={true}
                isClearable={false}
                hideSelectedOptions={false}
                value={getValue()}
                onChange={onChange}
                closeMenuOnSelect={false}
                isOptionSelected={isOptionSelected}
              />
              {/*)}*/}
              {/*<Button*/}
              {/*  color={'tertiary'}*/}
              {/*  sx={btnSearch(bg, searchInput)}*/}
              {/*  onClick={() => {*/}
              {/*    if (searchInput === false) {*/}
              {/*      setSearchInput(true);*/}
              {/*    }*/}
              {/*  }}*/}
              {/*  ref={wrapperRef}*/}
              {/*>*/}
              {/*  <SearchIcon*/}
              {/*    onClick={() => {*/}
              {/*      if (searchInputValue.length === 0) {*/}
              {/*        setSearchInput(false);*/}
              {/*      }*/}
              {/*    }}*/}
              {/*  />*/}
              {/*  <Collapse orientation="horizontal" in={searchInput} timeout={800}>*/}
              {/*    <OutlinedInput*/}
              {/*      sx={outlinedInput}*/}
              {/*      inputProps={{*/}
              {/*        style: inputStyle,*/}
              {/*      }}*/}
              {/*      inputRef={searchRef}*/}
              {/*      value={searchInputValue}*/}
              {/*      onChange={handleSearchInputValue}*/}
              {/*      endAdornment={*/}
              {/*        searchInputValue.length > 0 && (*/}
              {/*          <InputAdornment position="end" sx={inputAdornment}>*/}
              {/*            <CheckCircle onClick={handleSearch} />*/}
              {/*            <CloseIcon onClick={handleDeleteSearch} />*/}
              {/*          </InputAdornment>*/}
              {/*        )*/}
              {/*      }*/}
              {/*    />*/}
              {/*  </Collapse>*/}
              {/*</Button>*/}
              {bg && (
                <Filter
                  bg={bg}
                  selectedAccount={selectedAccount?.value}
                  btnId={btnId}
                  // searchValue={searchInputValue}
                  paymentType={paymentType}
                  setPaymentType={setPaymentType}
                  voen={voen}
                  setVoen={setVoen}
                  client={client}
                  setClient={setClient}
                  selectedPeriod={selectedPeriod}
                  setSelectedPeriod={setSelectedPeriod}
                  resNextDate={resNextDate}
                  setNextResDate={setNextResDate}
                  resEndDate={resEndDate}
                  setEndResDate={setEndResDate}
                  fromAmount={fromAmount}
                  setFromAmount={setFromAmount}
                  toAmount={toAmount}
                  setToAmount={setToAmount}
                  filterCounter={filterCounter}
                  setFilterCounter={setFilterCounter}
                  showCount={showCount}
                  setShowCount={setShowCount}
                  mainCount={mainCount}
                  setMainCount={setMainCount}
                  showFilter={showFilter}
                  setShowFilter={setShowFilter}
                  handleSubmitFilter={handleSubmitFilter}
                  isClean={isClean}
                  setIsClean={setIsClean}
                  resDate={resDate}
                  setResDate={setResDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  resetInputs={resetAllInput}
                  handleCheckData={handleCheckData}
                  setPage={setPage}
                  filterTransactionMutation={filterTransactionMutation}
                  accNo={accNo}
                  setAccNo={setAccNo}
                />
              )}
            </Box>
          </Box>
        )}

        <LastOperationsTable
          tableRow={
            dataFilterTransactions === undefined && !isLoadingFilterTransactions
              ? tableData
              : dataFilterTransactions?.transactions
          }
          loader={isLoadingFilterTransactions}
          bg={bg}
          handleMoveTransfer={handleMoveToTransfer}
          menuButtons={
            dataFilterTransactions === undefined && !isLoadingFilterTransactions
              ? menuHomeButtons
              : dataFilterTransactions?.buttons
          }
        />
        {bg && (
          <Pagination
            page={page}
            onChange={handleChangePage}
            sx={pagination}
            count={dataFilterTransactions?.counter !== undefined ? Math.ceil(dataFilterTransactions?.counter / 30) : 1}
            variant="outlined"
            shape="rounded"
          />
        )}
      </>
    );
  }
};

export default LastOperations;
